const listaUnidadesDeMedida = [
  {
    valor: 'und',
    nome: 'Unidade',
  },
  {
    valor: 'cx',
    nome: 'Caixa',
  },
  {
    valor: 'pct',
    nome: 'Pacote',
  },
  {
    valor: 'res',
    nome: 'Pacote de sulfite com 500 folhas',
  },
  {
    valor: 'kg',
    nome: 'Quilograma',
  },
  {
    valor: 'fr',
    nome: 'Frasco',
  },
  {
    valor: 'gl',
    nome: 'Galão',
  },
  {
    valor: 'sc',
    nome: 'Saco',
  },
  {
    valor: 'pc',
    nome: 'Peça',
  },
  {
    valor: 'kit',
    nome: 'Kit',
  },
  {
    valor: 'bob',
    nome: 'Bobina',
  },
  {
    valor: 'fl',
    nome: 'Folha',
  },
  {
    valor: 'mt',
    nome: 'Metro',
  },
  {
    valor: 'rol',
    nome: 'Rolo',
  },
  {
    valor: 'par',
    nome: 'Par',
  },
  {
    valor: 'dz',
    nome: 'Dúzia',
  },
  {
    valor: 'lt',
    nome: 'Litro',
  },
  {
    valor: 'g',
    nome: 'Grama',
  },
  {
    valor: 'mg',
    nome: 'Miligrama',
  },
  {
    valor: 'ml',
    nome: 'Mililitro',
  },
  {
    valor: 'm',
    nome: 'Metro',
  },
  {
    valor: 'cm',
    nome: 'Centímetro',
  },
  {
    valor: 'mm',
    nome: 'Milímetro',
  },
];

export default listaUnidadesDeMedida;
